import React, {useState} from 'react';
import { Col,Row} from "react-bootstrap";
import { useNavigate} from "react-router-dom";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import LahoreAntiqueBackGroundRemoved from "../../images/LahoreAntiqueBackGroundRemoved.png";
import LivingRoom4 from "../../images/LivingRoom4.png";
import LivingRoom1 from "../../images/LivingRoom1.png";
import LivingRoom2 from "../../images/LivingRoom2.png";
import BedRoom from "../../images/BedRoom.png";
import BannerTwo from "../../images/BannerTwo.png";
import exportImage from "../../images/importimage2.jpg";
import VideoOne from "../../images/Video1.mp4";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt, faCircleCheck} from "@fortawesome/free-solid-svg-icons";
import {ProductsList} from "../ProductsList/ProductsList";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Tooltip } from 'primereact/tooltip';

const Home = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [visible, setVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const bestSelling = ProductsList.slice(0, 3);
    return(
            <div className="bg-offWhite p-0">
                <Tooltip target=".eye-icon"/>
                    <NavBar products={ProductsList} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                <div style={{paddingTop:"11rem"}}>
                    <section className="fan-banner d-flex flex-column justify-content-between position-relative overflow-hidden">
                        <div className="fan-overlay position-absolute z-1"></div>
                        <div className="fan-container d-flex justify-content-between align-items-center position-relative z-2">
                            <div className="fan-left max-width-500">
                                <div className="fan-tag d-inline-block fs-14">AC / DC INVERTER SERIES</div>
                                <h1 className="lh-1 fw-bold fs-52 custom-fs-52">Smart <span className="text-yellow">Cooling</span><br/>Maximum <span className="text-yellow">Savings.</span></h1>
                                <p className="fan-sub my-3 mx-0 fs-16">Up to 75% Energy Saving with Powerful Air Delivery</p>
                                <ul className="fan-features p-0">
                                    <li><FontAwesomeIcon icon={faCircleCheck} className="me-2 text-success" />56" Sweep Size (1400 mm)</li>
                                    <li><FontAwesomeIcon icon={faCircleCheck} className="me-2 text-success" />360–365 RPM High Speed</li>
                                    <li><FontAwesomeIcon icon={faCircleCheck} className="me-2 text-success" />265–300 m³/min Air Delivery</li>
                                    <li><FontAwesomeIcon icon={faCircleCheck} className="me-2 text-success" />Works on WAPDA, UPS & Battery</li>
                                    <li><FontAwesomeIcon icon={faCircleCheck} className="me-2 text-success" />Only 50–55 Watts Consumption</li>
                                </ul>
                                <div className="fan-buttons mt-4 d-flex align-items-center">
                                    <button className="fan-buy br-30 fw-bold" onClick={()=>navigate("/products")}>Buy Now</button>
                                    <button className="fan-learn br-30">Learn More</button>
                                </div>
                            </div>
                            <div className="position-relative">
                                <img src={LahoreAntiqueBackGroundRemoved} alt="Lahore Antique BackGround Removed" className="custom-image-width" loading="lazy"/>
                                <div className="fan-badge position-absolute px-3 py-2 br-12 fw-bold"><FontAwesomeIcon icon={faBolt} className="me-2 text-warning"/>75% Energy Saving </div>
                            </div>
                        </div>
                        <div className="fan-bottom text-center p-3 fs-14">RF Inverter Technology | 12V DC Support | Up to 75% Energy Saving</div>
                    </section>
                    <Row className="m-0">
                        <Col lg={6} md={12} sm={12} className="living-custom mt-3 px-2">
                            <div className="LivingImageFour position-relative overflow-hidden" style={{ backgroundImage: `url(${LivingRoom4})` }} onClick={() => navigate("/product-details/nine-star")}>
                                <div className="shop-now-text position-absolute fw-bold fs-16 text-white br-20">Shop Now</div>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} className="living-custom mt-3 px-2">
                            <div className="LivingImageFour position-relative overflow-hidden" style={{ backgroundImage: `url(${BedRoom})` }} onClick={() => navigate("/product-details/two-down-antique")}>
                                <div className="shop-now-text position-absolute fw-bold fs-16 text-white br-20">Shop Now</div>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} className="living-custom mt-3 px-2">
                            <div className="LivingImageFour position-relative overflow-hidden" style={{ backgroundImage: `url(${LivingRoom1})` }} onClick={() => navigate("/product-details/lahore-model")}>
                                <div className="shop-now-text position-absolute fw-bold fs-16 text-white br-20">Shop Now</div>
                            </div>
                        </Col>
                        <Col lg={6} md={12} sm={12} className="living-custom mt-3 px-2">
                            <div className="LivingImageFour position-relative overflow-hidden" style={{ backgroundImage: `url(${LivingRoom2})` }} onClick={() => navigate("/product-details/magnum")}>
                                <div className="shop-now-text position-absolute fw-bold fs-16 text-white br-20">Shop Now</div>
                            </div>
                        </Col>
                    </Row>
                    <h1 className="fw-bold mt-5 text-center">Best Selling Products</h1>
                    <Row className="m-0 mt-4 justify-content-center">
                        {bestSelling.map((product, index) => (
                            <Col lg={4} md={4} key={index} className="px-3 mb-4">
                                <div className="product-card position-relative overflow-hidden">
                                    <img src={product.image} alt={product.name} className="w-100" style={{ height: "300px", objectFit: "contain" }} loading="lazy"/>
                                    <div className="product-overlay">
                                        <i className="pi pi-eye eye-icon" onClick={() => {setSelectedProduct(product);setVisible(true);}} data-pr-tooltip="Quick View"/>
                                    </div>
                                    <div className="p-3 text-center">
                                        <h5>{product.name}</h5>
                                        <p className="text-danger">{product.price}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Row className="m-0 my-5 px-2">
                        <div className="premium-banner position-relative w-100 overflow-hidden">
                            <img src={BannerTwo} alt="Banner Two" className="w-100" loading="lazy" />
                            <div className="banner-overlay position-absolute" />
                            <div className="banner-content position-absolute text-white">
                                <h1 className="fs-42 fw-bold mb-2">SKS Smart Home Series</h1>
                                <p className="fs-16 mb-4">Redefining comfort with elegance & intelligent design</p>
                                <button className="banner-btn"  onClick={() => navigate("/products")}>Explore Collection</button>
                            </div>
                        </div>
                    </Row>
                    <Row className="m-0 my-5">
                        <Col md={7} lg={7} sm={12}>
                            <video width="100%" controls autoPlay muted loop  style={{ borderRadius: "12px" }}>
                                <source src={VideoOne} type="video/mp4" />
                            </video>
                        </Col>
                        <Col md={5} lg={5} sm={12} className="d-flex align-items-center">
                            <div className="fan-text-box p-4 text-center">
                                <h6 className=" mb-4" style={{ color: "#A6CE3A", letterSpacing: "2px" }}>SKS FANS</h6>
                                <h2 className="fw-bold mb-3 gradient-text">
                                    A Stylish Choice for Every Room
                                </h2>
                                <p className="fs-14 custom-fs-14  ">
                                    SKS Fans are designed to keep you cool and comfortable during the hottest summer days.
                                    Combining elegant design with energy-efficient performance, they bring both style and practicality
                                    to your space. Every time you turn it on, it delivers a calm and refreshing breeze that enhances your comfort.
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="m-0 my-5 px-2">
                        <div className="premium-banner position-relative w-100 overflow-hidden">
                            <img src={exportImage} alt="Banner Two" className="w-100"  loading="lazy" />
                            <div className="banner-overlay position-absolute" />
                            <div className="banner-content position-absolute text-white">
                                <h1 className="fs-42 fw-bold mb-2">Export Inquries</h1>
                                <p className="fs-16 mb-4">Unlock global opportunities and become part of our international team.</p>
                                <a className="banner-btn" href="mailto:export@sksfans.com">export@sksfans.com</a>
                            </div>
                        </div>
                    </Row>
                    <Dialog visible={visible} style={{ width: "50vw" }} onHide={() => setVisible(false)}>
                        {selectedProduct && (
                            <div className="d-flex gap-4">
                                <div style={{ flex: 1 }}><img src={selectedProduct.image} alt="" className="w-100" loading="lazy"/></div>
                                <div style={{ flex: 1 }}>
                                    <h2>{selectedProduct.name}</h2>
                                    <span className="badge bg-light text-dark mb-2">
                                      {selectedProduct.series}
                                    </span>
                                    <h3 className="mt-2">{selectedProduct.price}</h3>
                                    <div className="my-2">
                                        <strong>Colors:</strong>
                                        <div className="d-flex gap-2 mt-2 custom-flex">
                                            {selectedProduct.colors.map((color, i) => (
                                                <img key={i} src={color.image} alt={color.name} style={{ width: "40px", cursor: "pointer" }} loading="lazy"/>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="my-2"><strong>Size:</strong> {selectedProduct.sizes[0]}</div>
                                    <div className="d-flex gap-2 mt-3">
                                        <Button className="mybtn w-100 text-white d-flex justify-content-center text-center" onClick={() => navigate(`${selectedProduct.path}/${selectedProduct.id}`)}>
                                            View Detail
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Dialog>
                    <Footer/>
                </div>
            </div>
    )
}
export default Home;